module.exports = __webpack_public_path__ + "static/media/19.a33312e7.jpg";